import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

import {
  AUTH_DEFAULT_PATH,
  USERS_DEFAULT_PATH,
} from '@digital-platform/aura-shared/domain';
import { Environment } from '@digital-platform/rs-shared/domain';
import { ENVIRONMENT } from '@digital-platform/rs-shared/services';
import {
  SHOULD_ATTACH_ACCESS_TOKEN,
  SHOULD_ATTACH_API_KEY,
} from '@digital-platform/rs-signup/services';

export interface UpdateProfilePayload {
  firstName: string;
  lastName: string;
  primaryPhone?: string;
}
export interface UpdateEmailPayload {
  firstName?: string;
  lastName?: string;
  currEmail?: string;
  currEmailCode?: string;
  newEmail?: string;
  newEmailCode?: string;
  userAttempts?: number;
}
@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private environment: Environment = inject(ENVIRONMENT);
  private readonly httpClient = inject(HttpClient);

  /**
   * Send Twilio OTP to email
   */
  public sendOtp(email: string): Observable<any> {
    const context = new HttpContext()
      .set(SHOULD_ATTACH_ACCESS_TOKEN, true)
      .set(SHOULD_ATTACH_API_KEY, true);

    //add localhost api key for local development
    // const headers = new HttpHeaders({
    //   'x-api-key': 'd41d8cd98f00b204e9800998ecf8427e',
    // });

    const request = this.httpClient
      .post(
        `${AUTH_DEFAULT_PATH}/v1/otp`,
        { email },
        {
          context,
          observe: 'response',
          //headers,
        }
      )
      .pipe(
        take(1),
        catchError((err: any) => throwError(() => err))
      );

    return request;
  }

  /**
   * Update Email Address after successful OTP verification
   */
  public updateEmail(payload: UpdateEmailPayload): Observable<any> {
    const context = new HttpContext()
      .set(SHOULD_ATTACH_ACCESS_TOKEN, true)
      .set(SHOULD_ATTACH_API_KEY, true);

    // add localhost api key for local development
    // const headers = new HttpHeaders({
    //   'x-api-key': 'd41d8cd98f00b204e9800998ecf8427e',
    // });

    const request = this.httpClient
      .patch(`${AUTH_DEFAULT_PATH}/profile/email`, payload, {
        context,
        observe: 'response',
        //headers,
      })
      .pipe(
        take(1),
        catchError((err: any) => throwError(() => err))
      );

    return request;
  }

  /**
   * Update Mini Profile
   */
  public update(
    payload: UpdateProfilePayload | UpdateEmailPayload
  ): Observable<any> {
    const context = new HttpContext()
      .set(SHOULD_ATTACH_ACCESS_TOKEN, true)
      .set(SHOULD_ATTACH_API_KEY, true);

    // add localhost api key for local development
    // const headers = new HttpHeaders({
    //   'x-api-key': 'd41d8cd98f00b204e9800998ecf8427e',
    // });

    const request = this.httpClient
      .put(`${USERS_DEFAULT_PATH}/profile`, payload, {
        context,
        observe: 'response',
        //headers,
      })
      .pipe(
        take(1),
        catchError((err: any) => throwError(() => err))
      );

    return request;
  }
}
